import { ConfigProvider, theme } from 'antd';
import { SELECT_THEME } from 'common/config/constant';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRootSlice } from 'store/slice';
import { selectTheme } from 'store/slice/selector';
import { StorageServices } from 'utils/storage';
import AppRoutes from './routers';
import { Toaster } from 'react-hot-toast';
import enUS from 'antd/locale/en_US';
import viVN from 'antd/locale/vi_VN';
import Empty from 'common/components/Empty/Empty';
import CustomToast from 'common/components/CustomToast/CustomToast';
import axiosInstance from 'common/config/axiosConfig';

function App() {
  const { actions: actionsRoot } = useRootSlice();
  const dispatch = useDispatch();
  const { defaultAlgorithm, darkAlgorithm } = theme;

  const themeStore = useSelector(selectTheme);

  const getCSSVariable = (name) =>
    getComputedStyle(document.documentElement).getPropertyValue(name).trim();

  useEffect(() => {
    const getTheme = StorageServices.getData(SELECT_THEME);
    dispatch(actionsRoot.changeTheme(getTheme));
    if (!getTheme) {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: light)');
      const theme = mediaQuery.matches ? 'dark' : 'light';
      StorageServices.setData(SELECT_THEME, theme);
      dispatch(actionsRoot.changeTheme(theme));
    }
  }, [actionsRoot, dispatch]);

  useEffect(() => {
    const fetchDomainCDN = async () => {
      try {
        const response = await axiosInstance.get(
          `/sso/security/get-domain-cdn`
        );

        StorageServices.setData('domainCDN', response.data.data.domain);
        StorageServices.setData(
          'domainCDN_protected',
          response.data.data.domain_protected
        );
      } catch (error) {
        console.error('Error fetching domain CDN:', error);
      }
    };

    fetchDomainCDN();
  }, []);

  return (
    <ConfigProvider
      pagination={{
        showSizeChanger: true,
      }}
      locale={StorageServices.getData('i18nextLng') === 'vi' ? viVN : enUS}
      renderEmpty={() => <Empty />}
      theme={{
        components: {
          Menu: {
            itemSelectedColor: 'white',
            itemSelectedBg: getCSSVariable('--primary-color'),
            itemActiveBg:
              themeStore === 'dark'
                ? getCSSVariable('--color-selected-dark')
                : getCSSVariable('--color-selected-light'),
            subMenuItemBg:
              themeStore === 'dark'
                ? getCSSVariable('--background-login-dark')
                : '#ffffff',
            activeBarBorderWidth: 0,
          },
          Button: {
            defaultHoverBorderColor: getCSSVariable('--tag-text-primary'),
            defaultHoverColor: getCSSVariable('--tag-text-primary'),
          },
          Tabs: {
            itemSelectedColor: getCSSVariable('--tag-text-primary'),
            itemHoverColor: getCSSVariable('--tag-text-primary'),
            inkBarColor: getCSSVariable('--tag-text-primary'),
          },
          Modal: {
            contentBg:
              themeStore === 'dark'
                ? getCSSVariable('--background-root-dark')
                : '#ffffff',
            headerBg:
              themeStore === 'dark'
                ? getCSSVariable('--background-root-dark')
                : '#ffffff',
          },
        },
        algorithm: themeStore === 'dark' ? darkAlgorithm : defaultAlgorithm,
        token: {
          colorBgContainer:
            themeStore === 'dark'
              ? getCSSVariable('--background-login-dark')
              : '#ffffff',
          colorText:
            themeStore === 'dark'
              ? getCSSVariable('--color-text-dark')
              : getCSSVariable('--color-text-light'),
        },
      }}
    >
      <AppRoutes />
      <Toaster position="top-right" gutter={8}>
        {(t) => <CustomToast {...t} />}
      </Toaster>
    </ConfigProvider>
  );
}

export default App;
